<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">
        <i class="fas fa-users-cog icon"></i>
        Encuestas
      </div>

      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link :to="{name:'administrativeHome'}">
                <span>
                  <i class="fas fa-home icon"></i>
                  inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{name: 'questionaries'}">
                <span>
                  <i class="fas fa-user-cog icon"></i>
                  Encuestas
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <CreateQuestionary
          v-if="isComponentModalActive"
          :isComponentModalActive="isComponentModalActive"
          :chargeQuestionarieList="chargeQuestionarieList"
          :closeBasic="closeBasic"
        ></CreateQuestionary>
        <AddQuestionsQuestionary
          v-if="OpenModalAddQuestions"
          :OpenModalAddQuestions="OpenModalAddQuestions"
          :closeBasic="closeBasic"
          :questionarie_id="questionarie_id"
        ></AddQuestionsQuestionary>
        <ShowQuestionary
          v-if="OpenModalShowQuestions"
          :OpenModalShowQuestions="OpenModalShowQuestions"
          :closeBasic="closeBasic"
          :questionarie_id="questionarie_id"
        ></ShowQuestionary>
        <EditQuestionary
          v-if="OpenModalEditQuestionary"
          :OpenModalEditQuestionary="OpenModalEditQuestionary"
          :closeBasic="closeBasic"
          :chargeQuestionarieList="chargeQuestionarieList"
          :questionarie_id="questionarie_id"
        ></EditQuestionary>
        <div class="box">
          <b-button type="is-primary is-small" @click="openBasic()">Crear Encuesta</b-button>

          <b-table
            type="is-primary"
            :data.sync="listQuestionarie"
            :loading="loading"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :is-fullwidth="true"
            default-sort="stablishment.name"
            aria-next-label="Next page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="name" label="Nombre">{{ props.row.name }}</b-table-column>
              <b-table-column field="state" label="Estado">
                <span class="tag is-success" v-if="props.row.state=='Abierta'">{{ props.row.state }}</span>
                <span class="tag is-danger" v-if="props.row.state=='Cerrada'">{{ props.row.state }}</span>
                <span class="tag is-info" v-if="props.row.state=='Creada'">{{ props.row.state }}</span>
                <span
                  class="tag is-warning"
                  v-if="props.row.state=='Invalida'"
                >{{ props.row.state }}</span>
              </b-table-column>
              <b-table-column field="date_start" label="Inicio">{{ props.row.date_start }}</b-table-column>
              <b-table-column field="date_end" label="Fin">{{ props.row.date_end }}</b-table-column>
              <b-table-column field="action" label="Acciones">
                <div class="buttons">
                  <b-tooltip
                    type="is-dark"
                    label="El cuestionario ya esta invalidado"
                    style="margin-right:1%"
                    :active="props.row.state=='Invalida'"
                  >
                    <b-button
                      type="is-danger is-small"
                      :disabled="props.row.state=='Invalida'"
                      @click="invalidQuestionary(props.row.id,'Invalida')"
                    >Invalidar</b-button>
                  </b-tooltip>

                  <b-tooltip
                    type="is-dark"
                    label="El Cuestionario ya no puede ser editado"
                    style="margin-right:1%"
                    :active="props.row.state=='Invalida'"
                  >
                    <b-button
                      :disabled="props.row.state=='Invalida'"
                      type="is-info is-small"
                      @click="openDialogEditQuestionary(props.row.id)"
                    >Editar</b-button>
                  </b-tooltip>
                  <b-tooltip
                    type="is-dark"
                    label="El cuestionario ya fue abierto en algun momento, por ende ya no se le pueden sumar preguntas"
                    style="margin-right:1%"
                    :active="props.row.state!='Creada'"
                  >
                    <b-button
                      type="is-primary is-small"
                      :disabled="props.row.state!='Creada'"
                      @click="openDialogAddQuestions(props.row.id)"
                    >Agregar Preguntas</b-button>
                  </b-tooltip>
                  <b-button
                    type="is-success is-small"
                    @click="openDialogShowQuestion(props.row.id)"
                  >Ver Encuesta</b-button>
                  <b-button
                    v-if="props.row.state=='Abierta'"
                    type="is-warning is-small"
                    @click="changeState(props.row.id,'Cerrada')"
                  >Cerrar Encuesta</b-button>
                  <b-button
                    v-if="props.row.state=='Creada'||props.row.state=='Cerrada'"
                    type="is-waring is-small"
                    @click="changeState(props.row.id,'Abierta')"
                  >Abrir Encuesta</b-button>
                </div>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from "../../../template/PlantillaContenido";
import CreateQuestionary from "../../../components/administrative/questionary/CreateQuestionary";
import AddQuestionsQuestionary from "../../../components/administrative/questionary/AddQuestionsQuestionary";
import ShowQuestionary from "../../../components/administrative/questionary/ShowQuestionary";
import EditQuestionary from "../../../components/administrative/questionary/EditQuestionary";
import { changeStateQuestionarie } from "../../../services/questionarie";

export default {
  components: {
    PlantillaContenido,
    CreateQuestionary,
    AddQuestionsQuestionary,
    ShowQuestionary,
    EditQuestionary,
  },
  data() {
    return {
      questionarie_id: null,
      listQuestionarie: [],
      isFullPage: true,
      isComponentModalActive: false,
      OpenModalAddQuestions: false,
      OpenModalShowQuestions: false,
      OpenModalEditQuestionary: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5,
    };
  },
  mounted: function () {
    this.chargeQuestionarieList();
  },
  methods: {
    openBasic() {
      this.isComponentModalActive = true;
    },
    openDialogAddQuestions(id) {
      (this.questionarie_id = id), (this.OpenModalAddQuestions = true);
    },
    openDialogShowQuestion(id) {
      (this.questionarie_id = id), (this.OpenModalShowQuestions = true);
    },
    openDialogEditQuestionary(id) {
      (this.questionarie_id = id), (this.OpenModalEditQuestionary = true);
    },
    closeBasic() {
      this.questionarie_id = null;
      this.isComponentModalActive = false;
      this.OpenModalAddQuestions = false;
      this.OpenModalShowQuestions = false;
      this.OpenModalEditQuestionary = false;
    },
    chargeQuestionarieList() {
      this.loading = true;
      this.listQuestionarie = [];
      this.$http.get(`api/${localStorage.getItem("perfil")}/questionary`).then(
        (response) => {
          this.listQuestionarie = response.body.data;
          this.loading = false;
        },
        (response) => {
          console.log("error: ", response);
        }
      );
    },
    async changeState(id, state) {
      this.$buefy.dialog.confirm({
        title: `¿Está seguro?`,
        message: `Esto dejará la encuesta como: ${state}, y ya no podrá realizar modificaciones a la encuesta`,
        confirmText: "Aceptar",
        type: "is-warning",
        hasIcon: true,
        onConfirm: async () => {
          let loader = this.$buefy.loading.open();
          await changeStateQuestionarie(this.$http, id, state).then(() => {
            loader.close();
            this.chargeQuestionarieList();
          });
        },
      });
    },
    async invalidQuestionary(id, state) {
      this.$buefy.dialog.confirm({
        title: `¿Está seguro?`,
        message: `Esto dejará invalidada la encuesta y tendrá que crearse nuevamente`,
        confirmText: "Aceptar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          let loader = this.$buefy.loading.open();
          await changeStateQuestionarie(this.$http, id, state).then(() => {
            loader.close();
            this.chargeQuestionarieList();
          });
        },
      });
    },
  },
};
</script>

